import Swal from 'sweetalert2'
import { mountVueComponent, unmountVueComponent } from './vue-core'
import type { Component } from 'vue'
import { useAuthStore } from '../stores/auth';

export const showVuePopup = async (
	component: Component,
	props: Record<string, any> = {},
	options: Partial<any> = {}
) => {
	const auth = useAuthStore()
	auth.hydrate()

	const wrapperId = 'vue-popup-' + Math.random().toString(36).substring(2, 8)

	const close = async () => Swal.close()

	await Swal.fire({
		title: '',
		html: `<div id="${wrapperId}"></div>`,
		showConfirmButton: false,
		showCloseButton: true,
		allowOutsideClick: false,
		customClass: {
			closeButton: 'absolute top-0 right-0 size-8! -translate-y-1/3 translate-x-1/3 bg-gray-100 hover:bg-gray-300 shadow rounded-full justify-center! items-center!',
			popup: 'bg-[url(https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/bg-profile-m_result.webp)] bg-size-[100%_100%] bg-center bg-transparent',
			htmlContainer: 'min-h-[36rem]',
			...(options.customClass || {}),
		},
		didOpen: () => {
			mountVueComponent(component, { ...props, close }, wrapperId)
			options.didOpen?.()
		},
		willClose: () => {
			unmountVueComponent(wrapperId)
			options.willClose?.()
		},
		...options,
	});
}
